import React from "react";
import Photo from "./Photo";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
function PhotoSlider() {
  return (
    <Fade bottom>
      <Container>
        <Title>
          <h2>Gallery</h2>
        </Title>

        <Photo />
      </Container>
    </Fade>
  );
}

const Container = styled.div`
  height: 100vh;

  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #161616;
  margin-top: 150px;
`;

const Title = styled.div`
  font-size: 26px;
  margin-bottom: 100px !important;
  color: #fff;
  align-self: center;
`;

export default PhotoSlider;
